module.exports = __webpack_public_path__ + "static/img/manual_ja_5.e23d76b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_5.png
// module id = yWeO
// module chunks = 4